import React, { lazy, Suspense } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { Box, CircularProgress } from '@mui/material';
import RequireAuth from './RequireAuth';
import LoginScreen from '../LoginScreen/LoginScreen';
import Header from '../Header/Header';
import Home from '../HomeScreen/Home/Home';
import NewFooter from '../Footer/NewFooter';
import Footer from '../Footer/Footer';
import { useCasinoEnabled } from '../../context/CasinoEnabledContext';


const CricketBetTab = lazy(() => import('../CricketBet/CricketBetTab'));
const FootballBetTab = lazy(() => import('../footballBet/FootballBetTab'));
const CasinoBetTab = lazy(() => import('../CasinoBet/CasinoBetTab'));
const Dragon_Tiger = lazy(() => import('../CasinoBet/Dragon_Tiger/Dragon_Tiger'));
const OtherGameGrid = lazy(() => import('../HomeScreen/OtherGameGrid/OtherGameGrid'));
const AccountStatement = lazy(() => import('../AccountStatement/AccountStatement'));
const AvaiatorStatement = lazy(() => import('../AvaiatorStatement/AvaiatorStatement'));
const CasinoStatement = lazy(() => import('../CasinoStatement/CasinoStatement'));
const GameStatement = lazy(() => import('../GameStatement/GameStatement'));
const ProfitandLoss = lazy(() => import('../ProfitandLoss/ProfitandLossSummary/ProfitandLoss'));
const DragonTigerSummary = lazy(() => import('../ProfitandLoss/DragonTigerSummary/DragonTigerSummary'));
const GameSummary = lazy(() => import('../ProfitandLoss/GameSummary/GameSummary'));
const GameSummaryStatement = lazy(() => import('../ProfitandLoss/GameSummaryStatement/GameSummaryStatement'));
const BetHistoryTab = lazy(() => import('../BetHistory/BetHistoryTab'));
const EditStack = lazy(() => import('../EditStack/EditStack'));
const WithdrawPage = lazy(() => import('../Header/bankAccount/WithdrawPage'));
const DepositPage = lazy(() => import('../Header/bankAccount/DepositPage'));
const BetDetails = lazy(() => import('../ProfitandLoss/ProfitandLossSummary/Bettable/BetDeatils'));
const Rules = lazy(() => import('../CricketBet/BOX/Rules/Rules'));
const CasinoBetHistoryTab = lazy(() => import('../Casino BetHistory/CasinoBetHistoryTab'));
const CasinoResultsPopup = lazy(() => import('../CasinoBet/Dragon_Tiger/CasinoResultsPopup'));


const PageLoader = () => (
    <Box sx={{ display: 'flex', justifyContent: 'center', alignItems: 'center', minHeight: '100vh' }}>
        <CircularProgress />
    </Box>
);

// Blocks casino routes when admin has turned Casino OFF (guest and logged-in)
const CasinoRoute = ({ children }) => {
    const { casinoEnabled, loading } = useCasinoEnabled();
    if (loading) return <PageLoader />;
    if (!casinoEnabled) return <Navigate to="/" replace />;
    return children;
};

function AllRoutes() {
    return (
        <Suspense fallback={<PageLoader />}>
            <Header />
            <Routes>
                <Route path='/login' element={<Navigate to="/" replace />} />
                <Route path='/' element={<Home />} />
                <Route path='/change-password' element={<LoginScreen />} />
                <Route path='/CricketBetTab/:etid/:gmid' element={<CricketBetTab />} />
                <Route path='/FootballBetTab/:etid/:gmid' element={<FootballBetTab />} />
                <Route path='/CasinoBetTab' element={<CasinoRoute><CasinoBetTab /></CasinoRoute>} />
                <Route path='/OtherGameGrid' element={<OtherGameGrid />} />
                <Route path='/Dragon_Tiger' element={<CasinoRoute><Dragon_Tiger /></CasinoRoute>} />
                <Route path='/AccountStatement' element={<RequireAuth><AccountStatement /></RequireAuth>} />
                <Route path='/ProfitandLoss' element={<RequireAuth><ProfitandLoss /></RequireAuth>} />
                <Route path="/CasinoStatement/:id" element={<CasinoRoute><RequireAuth><CasinoStatement /><NewFooter /></RequireAuth></CasinoRoute>} />
                <Route path="/AvaiatorStatement/:id" element={<CasinoRoute><RequireAuth><AvaiatorStatement /><NewFooter /></RequireAuth></CasinoRoute>} />
                <Route path="/GameStatement/:id/:selection/:marketType" element={<RequireAuth><GameStatement /></RequireAuth>} />
                <Route path="/DragonTigerSummary" element={<RequireAuth><DragonTigerSummary /><NewFooter /></RequireAuth>} />
                <Route path="/GameSummary/:id" element={<RequireAuth><GameSummary /><NewFooter /></RequireAuth>} />
                <Route path="/GameSummaryStatement/:id/:selection" element={<RequireAuth><GameSummaryStatement /><NewFooter /></RequireAuth>} />
                <Route path="/BetHistoryTab" element={<RequireAuth><BetHistoryTab /></RequireAuth>} />
                <Route path="/EditStack" element={<RequireAuth><EditStack /></RequireAuth>} />
                <Route path="/withdraw" element={<WithdrawPage />} />
                <Route path="/deposit" element={<DepositPage />} />
                <Route path="/bet-details/:id" element={<BetDetails />} />
                <Route path="/rules" element={<Rules />} />
                <Route path="/CasinoBetHistoryTab" element={<CasinoRoute><CasinoBetHistoryTab /></CasinoRoute>} />
                <Route path="/casino-results" element={<CasinoRoute><CasinoResultsPopup /></CasinoRoute>} />
            </Routes>
        </Suspense>
    );
}

export default AllRoutes;